import React, { Component } from "react";
import { Link } from "react-router-dom";

import { history, imagePath } from "utils";
import { Avatar } from "antd";
import { DOCUMENT_TYPE_PHOTO } from "constants/dbValues";

class UserIcon extends Component {
  render() {
    const { user, link, client } = this.props;
    const size = this.props.size || "default";

    const wrap = (content) =>
      link ? (
        <b
          className={client ? "client" : "user"}
          onClick={() => history.push(`/${client ? "clients" : "users"}/${user.id}`)}
        >
          {content}
        </b>
      ) : (
        <>{content}</>
      );
    const picture = null; //imagePath((user.document || {}).url, true);

    const renderInitals = () => {
      if (!user.name) return "";
      return client
        ? user.name.charAt(0).toUpperCase() + user.name.charAt(1)
        : user.name.charAt(0).toUpperCase() + user.surname.charAt(0).toUpperCase();
    };

    return picture
      ? wrap(<Avatar size={size} src={picture} />)
      : wrap(<Avatar size={size}>{renderInitals()}</Avatar>);
  }
}

export default UserIcon;
